
const animal = document.querySelector('#js-animal');
const progressBar = document.querySelector('#js-progressbar');
const goal = 50;
const actual = document.querySelector('.totals__subtotal-value');
var value = actual.getAttribute('id');
console.log(value);
updateProgressbar(parseFloat(value.replace(',', '.')));

//on('updateQuantity', function(event) { 
//    updateProgressbar(parseFloat($('.totals__subtotal-value > .value').first().text().replace(',', '.')));
//});
function updateProgressbar(actualAmount) {    
//	var reduc = $('#cart-subtotal-discount > .value').first();
//	if(reduc.length>0){
//		reduc = reduc.text().replace('-','');
//		reduc = reduc.replace(',','.');
//		reduc = parseFloat(reduc);
//		actualAmount = actualAmount- reduc;		
//	}
    const goal = 50;
    const actual = document.querySelector('.totals__subtotal-value');
    var value = actual.getAttribute('id');
    var Amount = value.replace(/\,/g,'.');
   console.log(Amount);
   console.log('toto');
    var actualGoal = Amount / 50;
  console.log(actualGoal);
	var percent = actualGoal * 100;
  console.log(percent);
    percent = (percent >= 100 ? 100 : Math.round(percent));
  
  console.log(goal);
    animal.style.setProperty('--move', percent + '%');
    progressBar.value = percent;
    let txt;
    if (percent == 100) {
        txt = 'Votre livraison est gratuite';
    } else {
        var result = Math.round((goal - Amount)*100)/100;
      let result2 = result.toFixed(2);
        txt = result2 +' € restants pour la livraison gratuite !';
    }
    $('.progress-text').text(txt);
}